import configuration from 'constants/config';
import { Realm } from 'further-types/global';
import { UserType } from 'further-types/user';

type User = {
  _id: string;
  userType?: UserType;
  investorRealm?: Realm;
};

const getUserType = (user?: User) => {
  const userIsAdviser = user?.userType === configuration.userType.advisor;
  const userIsOrg = user?.userType === configuration.userType.organisation;
  const userIsInvestor = user?.userType === configuration?.userType?.investor;
  const userIsLpInvestor = userIsInvestor && user?.investorRealm === Realm.Lp;
  const userIsEisInvestor = userIsInvestor && user?.investorRealm === Realm.Eis;

  return {
    userIsInvestor,
    userIsAdviser,
    userIsOrg,
    userIsLpInvestor,
    userIsEisInvestor,
  };
};

export default getUserType;
